import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "form-group" }

import { computed, toRef } from 'vue'

    import { CreatePortfolioEventPayload } from '@Quest/Portfolios/Components/PortfolioCreatorDialog'
    import type { PortfolioCreatorDialogViewModel } from '@Quest/Portfolios/Components/PortfolioCreatorDialog'
    import type { WorkspaceReadModel } from '@Organizations/Workspaces/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioCreatorDialog',
  props: {
    viewModel: {}
  },
  emits: ["create-portfolio"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const nameError = computed(() =>
        vm.value.errors?.find(e => e.Context === 'Name')?.Error ?? null
    )

    const workspaces = computed<WorkspaceReadModel[]>(() => vm.value.workspaces)

    // writable computeds (replace getter + setter pairs)

    const workspaceId = computed<number>({
        get: () => vm.value.workspaceId,
        set: v => { vm.value.workspaceId = v }
    })

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    const description = computed<string | null>({
        get: () => vm.value.description,
        set: v => { vm.value.description = v }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        vm.value.clearValidationErrors()

        emit(
            'create-portfolio',
            new CreatePortfolioEventPayload(
                workspaceId.value,
                name.value,
                description.value
            )
        )
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "modal-title" }, "Create portfolio", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  id: "portfolio-creator-dialog-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Workspace:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((workspaceId).value = $event)),
                      class: "form-control"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (w) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: w.WorkspaceId
                        }, _toDisplayString(w.Name), 9 /* TEXT, PROPS */, _hoisted_7))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, workspaceId.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Portfolio name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                      class: "form-control",
                      required: "",
                      maxlength: "100",
                      minlength: "2"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(nameError.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "Description (optional):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        description.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _cache[7] || (_cache[7] = _createElementVNode("button", {
                  type: "submit",
                  form: "portfolio-creator-dialog-form",
                  class: "btn btn-primary"
                }, "Create", -1 /* CACHED */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})